import React from 'react';

import { AmountWrapper, AmountInput } from '@domain/pay/components/AmountField';

import './AmountField.scss';

type AmountFieldProps = {
    info?: string;
};

export const AmountField = ({ info }: AmountFieldProps) => {
    return (
        <div className="amount-field">
            <AmountWrapper>
                <AmountInput />
                {info && <p className="transfer-charge-info">{info}</p>}
            </AmountWrapper>
        </div>
    );
};
